enum PgProvider {
  Cashfree = 'Cashfree',
  CashfreeNew = 'CashfreeNew',
  CashfreeInfo = 'CashfreeInfo',
  CashfreeHopkins = 'CashfreeHopkins',
  BillDesk = 'BillDesk',
}

export default PgProvider;
